import React from "react";
import { ReactNode, useEffect, useRef, useState } from "react";

function ExpandCarret(props: { expanded: boolean }) {
  return (
    <div
      style={{
        transform: props.expanded ? "rotateZ(0deg)" : "rotateZ(-90deg)",
        transition: ".2s",
        width: "10px",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
        fill="currentColor"
      >
        <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z" />
      </svg>
    </div>
  );
}

export default function Accordian({
  children,
  label,
  startExpanded,
  wrapperClass = "",
  iconBefore = false,
  extraStyling = {},
  observerSizeChanges = false,
  snap = false,
  buffer = 0,
}: {
  label: ReactNode;
  children: ReactNode;
  startExpanded: boolean;

  iconBefore?: boolean;
  observerSizeChanges?: boolean;
  snap?: boolean;
  extraStyling?: {};
  buffer?: number;
  wrapperClass?: string;
}) {
  const [isExpanded, setExpanded] = useState<boolean>(startExpanded);
  const [finishedExpanding, setFinishedExpanding] = useState<boolean>(true);
  const [isInitialized, setInitialized] = useState<boolean>(false);
  const expandContentRef = useRef<HTMLDivElement>(null);

  const resizeRef = useRef<HTMLDivElement>(null);
  const [mHieght, setMHeigvht] = useState(500);

  useEffect(() => {
    const resizeObserve = new ResizeObserver(
      (entries: ResizeObserverEntry[]) => {

        window.requestAnimationFrame(function () {
                
  
  
        for (let entry of entries) {
          const newH = entry.contentRect.height;
       
          if (Math.abs(newH - mHieght) > 2 && resizeRef.current && isExpanded)
            resizeRef.current.style.maxHeight = newH + "px";
        }
      });    
      }
    );

    if (expandContentRef.current && !isInitialized) {
      setMHeigvht(expandContentRef.current.getBoundingClientRect().height);
      setInitialized(true);
    }

    if (expandContentRef.current && observerSizeChanges)
      resizeObserve.observe(expandContentRef.current);




      
    return () => {
      resizeObserve.disconnect();
    };


//eslint-disable-next-line
  },[isExpanded]);

  const handleClick = () => {
    if (expandContentRef.current && finishedExpanding) {
      //recalc on every click just in case...
      setMHeigvht(expandContentRef.current.getBoundingClientRect().height);
    }
    setFinishedExpanding(false);
    setTimeout(()=>{
     // if(!finishedExpanding){
        setFinishedExpanding(true);
     // }

    },300)
    setExpanded(!isExpanded);
  };

  return (
    <>
      <div
        onClick={handleClick}
        className={
          isExpanded
            ? "accordian " + (wrapperClass??"")
            : "accordian expanded " + (wrapperClass??"")
        }
        style={
          iconBefore
            ? { justifyContent: "flex-start", ...extraStyling }
            : { justifyContent: "space-between", ...extraStyling }
        }
      >
        {iconBefore && <ExpandCarret expanded={isExpanded} />}
        {label}
        {!iconBefore && <ExpandCarret expanded={isExpanded} />}
      </div>

      <div
        ref={resizeRef}
        style={{
          overflow: (finishedExpanding && isExpanded)?"visible":"hidden",
          maxHeight: isExpanded ? (snap?"none": mHieght+buffer + "px") : "0px",
       
          transition: snap||(finishedExpanding)?"none":".3s",
        }}
      >
        {(isExpanded||!finishedExpanding)&&<div ref={expandContentRef}>{children}</div>}
      </div>
    </>
  );
}
